export const overviewContent = ({ t }) => ({
  hero: {
    eyebrow: t('competitive_intelligence_project_eyebrow'),
    title: t('competitive_intelligence_project_title'),
    subtitle: t('competitive_intelligence_project_subtitle'),
    description: t('competitive_intelligence_project_description'),
  },
  comparison: {
    title: t('competitive_intelligence_project_why_title'),
    beforeLabel: t('competitive_intelligence_project_before'),
    afterLabel: t('competitive_intelligence_project_now'),
    before: [
      t('competitive_intelligence_project_before_manual'),
      t('competitive_intelligence_project_before_missed'),
      t('competitive_intelligence_project_before_social'),
      t('competitive_intelligence_project_before_events'),
    ],
    after: [
      t('competitive_intelligence_project_now_schedule'),
      t('competitive_intelligence_project_now_clearances'),
      t('competitive_intelligence_project_now_social'),
      t('competitive_intelligence_project_now_events'),
    ],
  },
  pipeline: {
    title: t('competitive_intelligence_project_how_title'),
    subtitle: t('competitive_intelligence_project_how_subtitle'),
    retryLabel: t('competitive_intelligence_project_retry_loop'),
    note: t('competitive_intelligence_project_pipeline_note'),
    steps: [
      { key: 'decompose', title: t('competitive_intelligence_project_step_decompose'), description: t('competitive_intelligence_project_step_decompose_description'), tool: 'OpenRouter' },
      { key: 'search', title: t('competitive_intelligence_project_step_search'), description: t('competitive_intelligence_project_step_search_description'), tool: 'Tavily' },
      { key: 'evaluate', title: t('competitive_intelligence_project_step_evaluate'), description: t('competitive_intelligence_project_step_evaluate_description'), tool: 'OpenRouter' },
      { key: 'retry', title: t('competitive_intelligence_project_step_retry'), description: t('competitive_intelligence_project_step_retry_description'), tool: 'OpenRouter + Tavily' },
      { key: 'synthesise', title: t('competitive_intelligence_project_step_synthesise'), description: t('competitive_intelligence_project_step_synthesise_description'), tool: 'OpenRouter' },
    ],
  },
  intelligence: {
    title: t('competitive_intelligence_project_modules_title'),
    subtitle: t('competitive_intelligence_project_modules_subtitle'),
    modules: [
      {
        key: 'events', title: t('competitive_intelligence_project_events_title'), description: t('competitive_intelligence_project_events_description'),
        findings: [t('competitive_intelligence_project_events_finding_1'), t('competitive_intelligence_project_events_finding_2'), t('competitive_intelligence_project_events_finding_3')], tools: ['OpenRouter'],
      },
      {
        key: 'news', title: t('competitive_intelligence_project_news_title'), description: t('competitive_intelligence_project_news_description'),
        findings: [t('competitive_intelligence_project_news_finding_1'), t('competitive_intelligence_project_news_finding_2'), t('competitive_intelligence_project_news_finding_3')], tools: ['Tavily', 'OpenRouter'],
      },
      {
        key: 'social', title: t('competitive_intelligence_project_social_title'), description: t('competitive_intelligence_project_social_description'),
        findings: [t('competitive_intelligence_project_social_finding_1'), t('competitive_intelligence_project_social_finding_2'), t('competitive_intelligence_project_social_finding_3')], tools: ['Tavily', 'Playwright', 'OpenRouter'],
      },
    ],
  },
  research: {
    title: t('competitive_intelligence_project_research_title'),
    subtitle: t('competitive_intelligence_project_research_subtitle'),
    sources: [
      { key: 'pubmed', title: 'PubMed', description: t('competitive_intelligence_project_pubmed_description'), findings: [t('competitive_intelligence_project_pubmed_finding_1'), t('competitive_intelligence_project_pubmed_finding_2'), t('competitive_intelligence_project_pubmed_finding_3')] },
      { key: 'clinical-trials', title: 'ClinicalTrials.gov', description: t('competitive_intelligence_project_trials_description'), findings: [t('competitive_intelligence_project_trials_finding_1'), t('competitive_intelligence_project_trials_finding_2'), t('competitive_intelligence_project_trials_finding_3')] },
      { key: 'fda', title: 'FDA 510(k)', description: t('competitive_intelligence_project_fda_description'), findings: [t('competitive_intelligence_project_fda_finding_1'), t('competitive_intelligence_project_fda_finding_2'), t('competitive_intelligence_project_fda_finding_3'), t('competitive_intelligence_project_fda_finding_4')] },
    ],
    panel: {
      searchedTitle: t('competitive_intelligence_project_searched_title'),
      searchedDescription: t('competitive_intelligence_project_searched_description'),
      competitorsTitle: t('competitive_intelligence_project_competitors_title'),
      competitors: t('competitive_intelligence_project_competitors_text'),
      conditionsTitle: t('competitive_intelligence_project_conditions_title'),
      conditions: t('competitive_intelligence_project_conditions_text'),
      conditionsNote: t('competitive_intelligence_project_conditions_note'),
      examplesTitle: t('competitive_intelligence_project_examples_title'),
      examples: [
        ['PubMed', '(BrainsWay OR Brainsway) AND (depression OR "major depressive disorder" OR MDD OR "treatment-resistant depression") AND (TMS OR rTMS OR "deep TMS" OR iTBS OR "theta burst")'],
        ['ClinicalTrials', 'competitor: "Neuronetics OR NeuroStar" · condition: "OCD OR obsessive-compulsive disorder" · intervention: "TMS"'],
        ['FDA 510(k)', 'product_code: OBP · decision_date: [2008-01-01 TO *] → filter applicants against known competitors'],
      ],
      queryNote: t('competitive_intelligence_project_query_note'),
      scheduleTitle: t('competitive_intelligence_project_schedule_title'),
      scheduleDescription: t('competitive_intelligence_project_schedule_description'),
      expectationsTitle: t('competitive_intelligence_project_expectations_title'),
      expectations: [
        t('competitive_intelligence_project_expectation_trials'),
        t('competitive_intelligence_project_expectation_fda'),
        t('competitive_intelligence_project_expectation_signal'),
        t('competitive_intelligence_project_expectation_deduplication'),
        t('competitive_intelligence_project_expectation_directional'),
      ],
    },
  },
  technology: {
    title: t('competitive_intelligence_project_technology_title'),
    items: [
      ['openrouter', 'OpenRouter', t('competitive_intelligence_project_technology_openrouter')],
      ['tavily', 'Tavily', t('competitive_intelligence_project_technology_tavily')],
      ['playwright', 'Playwright', t('competitive_intelligence_project_technology_playwright')],
      ['fastapi', 'FastAPI', t('competitive_intelligence_project_technology_fastapi')],
      ['sqlite', 'SQLite', t('competitive_intelligence_project_technology_sqlite')],
      ['github', 'GitHub Actions', t('competitive_intelligence_project_technology_github')],
    ],
  },
  operations: {
    title: t('competitive_intelligence_project_operations_title'),
    value: t('competitive_intelligence_project_operations_value'),
    description: t('competitive_intelligence_project_operations_description'),
    items: [
      ['Universe', t('competitive_intelligence_project_operations_universe')],
      ['Strapi', t('competitive_intelligence_project_operations_strapi')],
      ['FastAPI', t('competitive_intelligence_project_operations_fastapi')],
      ['GitHub', t('competitive_intelligence_project_operations_github')],
      ['SQLite', t('competitive_intelligence_project_operations_sqlite')],
    ],
    note: t('competitive_intelligence_project_operations_note'),
  },
  status: {
    title: t('competitive_intelligence_project_status_title'),
    phases: [
      { key: 'done', badge: t('competitive_intelligence_project_status_complete'), title: t('competitive_intelligence_project_status_foundation_title'), description: t('competitive_intelligence_project_status_foundation_description') },
      { key: 'done', badge: t('competitive_intelligence_project_status_complete'), title: t('competitive_intelligence_project_status_integration_title'), description: t('competitive_intelligence_project_status_integration_description') },
      { key: 'next', badge: t('competitive_intelligence_project_status_next'), title: t('competitive_intelligence_project_status_operations_title'), description: t('competitive_intelligence_project_status_operations_description') },
      { key: 'future', badge: t('competitive_intelligence_project_status_planned'), title: t('competitive_intelligence_project_status_future_title'), description: t('competitive_intelligence_project_status_future_description') },
    ],
  },
})
